import { createAction } from '@reduxjs/toolkit';

export const revertCatalogStores = createAction('RevertCatalogStores');
